import { render, staticRenderFns } from "./real.vue?vue&type=template&id=6156af49"
import script from "./real.vue?vue&type=script&lang=js"
export * from "./real.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports